import styled from 'styled-components'

export const RowDiv = styled.div`
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 16px 0;
    align-items: center;
    button {
        padding: 5px 20px;
    }
`
